// extracted by mini-css-extract-plugin
module.exports = {"container":"PopUp_container__2pJwU","close":"PopUp_close__2EqEB","body":"PopUp_body__6YhXK"};